export const TYPE_PEW = 'pew'
export const TYPE_OXYGEN = 'oxygen'
export const TYPE_TEMPERATURE = 'temperature'
export const TYPE_SPEED = 'speed'
export const TYPE_TIDE = 'tide'
export const TYPE_SATURATION = 'saturation'
export const TYPE_TRANSPARENCY = 'visibility'
export const TYPE_CLOUD_COVER = 'cloud_cover'

export const CHART_TYPE_SENSORS = 'sensors'
export const CHART_TYPE_FORECAST = 'forecast'
export const CHART_TYPE_HISTORICAL = 'historical'

export const MODULE_A = 'moduleA'
export const MODULE_B = 'moduleB'
export const TYPE_SENSOR = 'sensor'
export const TYPE_WEATHER = 'weather'

export const DEFAULT_CLOUD_COVER_MAX_VALUE = 100
export const DEFAULT_MIN_VALUE = 0

const CHART_LIST_NAMES = {
  saturation: 'Saturation',
  cloudCover: 'Cloud Cover',
}

export const viewList = [
  { name: 'pew', component: TYPE_PEW },
  { name: 'saturation', component: TYPE_SATURATION },
  { name: 'oxygen', component: TYPE_OXYGEN },
  { name: 'transparency', component: TYPE_TRANSPARENCY },
  { name: 'speed', component: TYPE_SPEED },
  { name: 'cloudCover', component: TYPE_CLOUD_COVER },
  { name: 'tide', component: TYPE_TIDE },
  { name: 'temperature', component: TYPE_TEMPERATURE },
]

export const listViewList = ['min', 'max', 'avg', 'std']

export const depthRange = [5, 10, 15]

export const getPewScoreStatus = score => {
  if (score >= 80) {
    return 'green'
  }
  if (score >= 60) {
    return 'yellow'
  }

  return 'red'
}

export const getPewStatus = (oxygen, temperature, current, tide) => {
  let pew = 0
  if (oxygen > 5.5) {
    pew = 1
    if (temperature >= 5 || temperature <= 20) {
      pew = 2
      if (current <= 20) {
        pew = 3
        if (tide <= 5) {
          pew = 4
        }
      }
    }
  }

  return pew
}

export const isBoundaryLineShow = (
  dataArray,
  chartType,
  boundaryValue,
  checkBound,
) => {
  const lines = {
    level: boundaryValue,
    line: false,
  }

  if (dataArray.length < 1) {
    return lines
  }

  if (chartType === CHART_TYPE_FORECAST) {
    const checkForDataLength =
      dataArray.length > 1 ? dataArray[1].data : dataArray[0].data
    const data =
      dataArray[0].label === 'Tide' ? dataArray[0].data : checkForDataLength

    data.forEach(item => {
      if (lines.level.length !== undefined) {
        if (item.y < lines.level[0]) {
          lines.line = true
          lines.level = boundaryValue[0]
        }
        if (item.y > lines.level[1]) {
          lines.line = true
          lines.level = boundaryValue[1]
        }
      } else if (checkBound && checkBound(item.y)) {
        lines.line = true
        lines.level = boundaryValue
      }
    })
  } else {
    for (const k in dataArray) {
      if (dataArray.hasOwnProperty(k)) {
        const { data } = dataArray[k]

        if (data !== undefined) {
          data.forEach(item => {
            if (lines.level.length !== undefined) {
              if (item.y < boundaryValue[0]) {
                lines.line = true
                lines.level = boundaryValue[0]
              }
              if (item.y > boundaryValue[1]) {
                lines.line = true
                lines.level = boundaryValue[1]
              }
            } else if (checkBound && checkBound(item.y)) {
              lines.line = true
              lines.level = boundaryValue
            }
          })
        }
      }
    }
  }

  return lines
}

export const getMinRangeLimit = chartData => {
  const data = chartData.get('data').toJS()

  if (!data.length || !data[0].data.length) {
    return DEFAULT_MIN_VALUE
  }

  let minVal = data[0].data[0].y

  const findMinVal = i => {
    data[i].data.forEach(elem => {
      if (elem.y < minVal) {
        minVal = elem.y
      }
    })

    return minVal
  }

  let isSaturatonChart = false

  for (let i = 0; i < data.length; i += 1) {
    switch (data[i].label) {
      case CHART_LIST_NAMES.cloudCover:
        return DEFAULT_MIN_VALUE
      case CHART_LIST_NAMES.saturation:
        isSaturatonChart = true
        break
      default:
        findMinVal(i)
    }
  }

  if (isSaturatonChart) {
    return Math.round(minVal * 0.9)
  }

  return parseFloat((minVal * 0.9).toFixed(1))
}

export const getMaxRangeLimit = chartData => {
  const data = chartData.get('data').toJS()

  if (!data.length) {
    return DEFAULT_MIN_VALUE
  }

  let maxVal = 0

  const findMaxVal = i => {
    data[i].data.forEach(elem => {
      if (elem.y > maxVal) {
        maxVal = elem.y
      }
    })

    return maxVal
  }

  let isSaturatonChart = false

  for (let i = 0; i < data.length; i += 1) {
    switch (data[i].label) {
      case CHART_LIST_NAMES.cloudCover:
        return DEFAULT_CLOUD_COVER_MAX_VALUE
      case CHART_LIST_NAMES.saturation:
        isSaturatonChart = true
        break
      default:
        findMaxVal(i)
    }
  }

  if (isSaturatonChart) {
    return Math.round(maxVal * 1.1)
  }

  return parseFloat((maxVal * 1.1).toFixed(1))
}

const defaultWeatherObject = {
  low: null,
  high: null,
  now: null,
  last_updated: null,
}

const defaultSensorsObject = {
  '5': {
    value: null,
    time: '00:00',
  },
  '10': {
    value: null,
    time: '00:00',
  },
  '15': {
    value: null,
    time: '00:00',
  },
}

export const getDefaultWeatherObject = () => ({
  tide: { ...defaultWeatherObject },
  temperature: { ...defaultWeatherObject },
  windSpeed: { ...defaultWeatherObject },
  windDirection: { ...defaultWeatherObject },
})

export const getDefaultSensorsObject = () => ({
  saturation: { ...defaultSensorsObject },
  oxygen: { ...defaultSensorsObject },
  temperature: { ...defaultSensorsObject },
  speed: { ...defaultSensorsObject },
})
